export enum RefillsSaturationStatus {
  ACCEPTABLE = 'green',
  OVERLOADED = 'yellow',
  CRITICAL = 'red',
  NONE = 'black50'
}
